(function () {
  function starString(n) {
    n = Math.max(0, Math.min(5, Math.round(n)));
    return '★★★★★☆☆☆☆☆'.slice(5 - n, 10 - n);
  }

  function initWidget(root) {
    var src = root.getAttribute('data-src');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 8;
    var listEl = root.querySelector('[data-rf-list]');
    var summaryEl = root.querySelector('[data-rf-summary]');
    var scoreEl = root.querySelector('[data-rf-score]');
    var avgStarsEl = root.querySelector('[data-rf-avg-stars]');
    var countEl = root.querySelector('[data-rf-count]');
    var barsEl = root.querySelector('[data-rf-bars]');
    var moreWrap = root.querySelector('[data-rf-more-wrap]');
    var moreBtn = root.querySelector('[data-rf-more]');
    var emptyEl = root.querySelector('[data-rf-empty]');
    if (!src || !listEl) return;

    fetch(src)
      .then(function (r) { return r.json(); })
      .then(function (reviews) {
        if (!Array.isArray(reviews) || !reviews.length) {
          if (emptyEl) emptyEl.hidden = false;
          return;
        }
        var total = reviews.length;
        var sum = 0;
        var dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        reviews.forEach(function (rv) {
          sum += rv.r;
          dist[rv.r] = (dist[rv.r] || 0) + 1;
        });
        var avg = sum / total;

        if (summaryEl) {
          if (scoreEl) scoreEl.textContent = avg.toFixed(1);
          if (avgStarsEl) avgStarsEl.textContent = starString(avg);
          if (countEl) countEl.textContent = 'based on ' + total + ' review' + (total === 1 ? '' : 's');
          if (barsEl) {
            [5, 4, 3, 2, 1].forEach(function (n) {
              var c = dist[n] || 0;
              var pct = total ? Math.round((c / total) * 100) : 0;
              var row = document.createElement('div');
              row.className = 'rf-bar';
              var label = document.createElement('span');
              label.textContent = n + ' star';
              var track = document.createElement('span');
              track.className = 'rf-bar__track';
              var fill = document.createElement('span');
              fill.className = 'rf-bar__fill';
              fill.style.width = pct + '%';
              track.appendChild(fill);
              var count = document.createElement('span');
              count.className = 'rf-bar__count';
              count.textContent = String(c);
              row.appendChild(label);
              row.appendChild(track);
              row.appendChild(count);
              barsEl.appendChild(row);
            });
          }
          summaryEl.hidden = false;
        }

        // Photo and video reviews are the most eye-catching — surface them
        // first so they're visible without needing "Load more". Stable sort
        // keeps everything else in its original (newest-first) order.
        // A review may carry a photo (p) and/or a video (v, an .mp4 URL).
        var ordered = reviews
          .map(function (rv, i) { return { rv: rv, i: i }; })
          .sort(function (a, b) {
            var pa = (a.rv.p || a.rv.v) ? 1 : 0;
            var pb = (b.rv.p || b.rv.v) ? 1 : 0;
            if (pa !== pb) return pb - pa;
            return a.i - b.i;
          })
          .map(function (x) { return x.rv; });

        var shown = 0;
        function renderNext() {
          var slice = ordered.slice(shown, shown + perPage);
          slice.forEach(function (rv) {
            var card = document.createElement('div');
            card.className = 'rf-review' + ((rv.p || rv.v) ? ' rf-review--with-photo' : '');

            var main = document.createElement('div');
            main.className = 'rf-review__main';

            var stars = document.createElement('div');
            stars.className = 'rf-review__stars';
            stars.setAttribute('aria-hidden', 'true');
            stars.textContent = starString(rv.r);
            main.appendChild(stars);

            if (rv.b) {
              var quote = document.createElement('p');
              quote.className = 'rf-review__quote';
              quote.textContent = rv.b;
              main.appendChild(quote);
            }

            var byline = document.createElement('p');
            byline.className = 'rf-review__byline';
            byline.textContent = rv.n || 'Customer';
            main.appendChild(byline);

            var meta = document.createElement('p');
            meta.className = 'rf-review__meta';
            meta.textContent = rv.d || '';
            main.appendChild(meta);

            card.appendChild(main);

            if (rv.p || rv.v) {
              var photoWrap = document.createElement('div');
              photoWrap.className = 'rf-review__photo-wrap';
              if (rv.p) {
                var img = document.createElement('img');
                img.className = 'rf-review__photo';
                img.src = rv.p;
                img.loading = 'lazy';
                img.alt = (rv.n || 'Customer') + '’s photo';
                photoWrap.appendChild(img);
              }
              if (rv.v) {
                var video = document.createElement('video');
                video.className = 'rf-review__photo rf-review__video';
                video.src = rv.v;
                if (rv.p) video.poster = rv.p;
                video.controls = true;
                video.preload = 'metadata';
                video.setAttribute('playsinline', '');
                video.setAttribute('aria-label', (rv.n || 'Customer') + '’s video');
                photoWrap.appendChild(video);
              }
              card.appendChild(photoWrap);
            }

            listEl.appendChild(card);
          });
          shown += slice.length;
          if (moreWrap) moreWrap.hidden = shown >= ordered.length;
        }

        renderNext();
        if (moreBtn) moreBtn.addEventListener('click', renderNext);
      })
      .catch(function () {
        if (emptyEl) emptyEl.hidden = false;
      });
  }

  function initAll() {
    document.querySelectorAll('[data-linua-reviews]').forEach(function (root) {
      if (root.getAttribute('data-linua-reviews-init')) return;
      root.setAttribute('data-linua-reviews-init', 'true');
      initWidget(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
